export default "__VITE_ASSET__Vj2CQmkx__"